














import { Vue, Component, Prop } from "vue-property-decorator";
import { Activities } from "../../_models/activities";
import * as activity from "../../_store/activity.module";
import * as user from "../../_store/user.module";
import * as auth from "../../_store/auth.module";
import NoActivity from "../../components/Error/NoActivity.vue";
import CardTitle from "../../components/CardTitle.vue";
import { bus } from "../../main";
import { userUtils } from "../../_utils/userUtils";

@Component({
  components: {
    NoActivity,
    CardTitle
  }
})
export default class IncontriAzienda extends Vue {
  private incontriStatus: boolean;
  private titleParams: object;

  constructor() {
    super();
    this.titleParams = {
      title: "Tavola Rotonda",
      cols: "10",
      sm: "5",
      md: "5",
      lg: "4"
    };
    this.incontriStatus = false;
  }

  checkStatus(activities: Activities[]): boolean {
    var flag: boolean = false;
    activities.forEach(element => {
      if (element.incontro === true) {
        flag = true;
      }
    });
    return flag;
  }

  created() {
    var token = localStorage.getItem("userToken");
    var parsedToken: any;
    if (token !== null) {
      parsedToken = userUtils.parseToken(token);
    }
    var payload = {
      idUtente: parsedToken.IdUtente,
      tipoSoggetto: parsedToken.IdTipoSoggetto,
      username: parsedToken.Username
    };
    user
      .dispatchSetUserInfo(this["$store"], payload)
      .then(() => {
        user
          .dispatchSetEnterpriseInfo(this["$store"])
          .then(() => {
            bus.$emit("loadMenu");
            var enterpriseInfo = user.readEnterpriseInfo(this["$store"]);
            var activities: Activities[];
            activity
              .dispatchGetActivityState(this["$store"], enterpriseInfo.idAzienda)
              .then(() => {
                activities = activity.readActivityState(this["$store"]);
                this.incontriStatus = this.checkStatus(activities);
              })
              .catch(error => {
                bus.$emit(
                  "errorOperation",
                  "Errore nel caricamento dei periodi attività"
                );
              });
          })
          .catch(() => {
            bus.$emit("stopLoading");
            auth.dispatchLogout(this["$store"]);
            user.dispatchClearState(this["$store"]);
            this["$router"].push("/sessionExpired");
          });
      })
      .catch(() => {
        bus.$emit("stopLoading");
        auth.dispatchLogout(this["$store"]);
        user.dispatchClearState(this["$store"]);
        this["$router"].push("/sessionExpired");
      });
  }

  // created() {
  //   var activities: Activities;
  //   activity.dispatchSetActivityState(this["$store"]).then(() => {
  //     activities = activity.readActivitiesStatus(this["$store"]);
  //     this.incontriStatus = activities.incontro;
  //   });
  // }
}
